// start:ng42.barrel
export * from './upload.component';
export * from './upload.module';
// end:ng42.barrel

